/* eslint-disable no-case-declarations */
import produce, { Draft } from 'immer';
import { LeadType, Meta } from 'types/lead';
import {
  listEhrSyncIssues,
  modalSetClosed,
  modalOpenSetNotFound,
  modalSelectItem,
  modalInputEhrPatientId,
  modalClean,
  listEhrSyncInfo,
  ehrSyncLastUpdated,
  ehrSyncManualAll,
  ehrSyncManualItems,
  ehrSyncManualItemsFinish,
} from './actions';

export type EhrSyncState = {
  syncItems: string[];
  list: {
    sync: boolean;
    lastUpdated: Date | undefined;
    loading: boolean;
    error: string | Error | undefined;
    items: LeadType[];
    meta: Meta;
  };
  modalMatches: {
    isOpen: {
      notFound: boolean;
      manyMatches: boolean;
    };
    loading: boolean;
    error: string | Error | undefined;
    items: LeadType[];
    submitting: boolean;
    selectLeadId: string | undefined;
    selectedItem: string | undefined;
    inputEhrPatientId: string | undefined;
    title: string | undefined;
    message: string | undefined;
  };
};

const initialState: EhrSyncState = {
  syncItems: [],
  list: {
    sync: false,
    lastUpdated: undefined,
    loading: false,
    error: undefined,
    items: [],
    meta: {
      totalItems: 0,
      itemCount: 0,
      itemsPerPage: 10,
      totalPages: 0,
      currentPage: 1,
    },
  },
  modalMatches: {
    isOpen: {
      notFound: false,
      manyMatches: false,
    },
    loading: false,
    error: undefined,
    items: [],
    submitting: false,
    selectLeadId: undefined,
    selectedItem: undefined,
    inputEhrPatientId: undefined,
    title: undefined,
    message: undefined,
  },
};

const reducer = produce((draft: Draft<EhrSyncState>, { type, payload }) => {
  switch (type) {
    case listEhrSyncIssues.TRIGGER:
      draft.list.loading = true;
      draft.list.error = undefined;
      break;
    case listEhrSyncIssues.SUCCESS:
      draft.list.items = payload.items;
      draft.list.meta = payload.meta;
      break;
    case listEhrSyncIssues.FAILURE:
      draft.list.error = payload;
      break;
    case listEhrSyncIssues.FULFILL:
      draft.list.loading = false;
      break;
    case modalSetClosed.toString():
      draft.modalMatches.isOpen = {
        notFound: false,
        manyMatches: false,
      };
      break;
    case modalOpenSetNotFound.toString():
      draft.modalMatches.isOpen = {
        notFound: payload.isOpen,
        manyMatches: false,
      };
      draft.modalMatches.selectLeadId = payload.leadId;
      draft.modalMatches.title = payload.title;
      draft.modalMatches.message = payload.message;
      break;
    case modalSelectItem.toString():
      draft.modalMatches.selectedItem = payload;
      break;
    case modalInputEhrPatientId.toString():
      draft.modalMatches.inputEhrPatientId = payload;
      break;
    case modalClean.toString():
      draft.modalMatches = initialState.modalMatches;
      break;
    case listEhrSyncInfo.SUCCESS:
      draft.list.lastUpdated = payload?.metadata?.lastUpdate;
      draft.list.sync = payload?.metadata?.syncManualAll ?? false;
      draft.syncItems = payload?.metadata?.syncManualItems ?? [];
      break;
    case ehrSyncManualAll.toString():
      draft.list.sync = payload.syncManualAll ?? false;
      break;
    case ehrSyncManualItems.toString():
      draft.syncItems = payload.items ?? [];
      break;
    case ehrSyncManualItemsFinish.toString():
      draft.syncItems = draft.syncItems.filter(
        (id: string) => id !== payload.id,
      );
      break;
    case ehrSyncLastUpdated.toString():
      // TODO: Backend payload changed: was a raw string, now an object
      // { lastUpdated: string, ehrProvider: string | null }.
      // Support both shapes during the migration period.
      draft.list.lastUpdated =
        typeof payload === 'string' ? payload : payload?.lastUpdated;
      break;
    default:
      break;
  }
}, initialState);

export default reducer;
